import { v4 as uuidv4 } from "uuid";
import { resolveDuctArticle } from "./dummyDucts";

/**
 * Build SectionPlacement objects from Scenario.Sections.
 *
 * @param {Scenario} scenario
 * @param {EnclosurePlacement} enclosure
 * @returns SectionPlacement[]
 */
export async function buildSectionPlacements(scenario, enclosure) {
  // 1) Determine ordering from scenario sequences
  const defaultSeq =
    scenario.sequences?.find((s) => s.isDefault) ??
    scenario.sequences?.[0] ??
    null;

  const orders = defaultSeq?.items || [];

  function getOrderFor(sectionId) {
    const o = orders.find((x) => x.sectionId === sectionId);
    return o?.order ?? 999;
  }

  // One lookup for all sections; placeholder when nothing is selected
  const ductArticle = await resolveDuctArticle(
    scenario.settings?.ductsSectionsId,
    "sections",
  );

  const plateWidth =
    enclosure?.montagePlacement?.size?.width ?? enclosure?.size?.width ?? 0;
  const sideDuctWidth = enclosure?.ductLeft?.size?.width ?? 0;

  function createTopDuct(parentId) {
    return {
      id: uuidv4(),
      parentId,
      referenceId: ductArticle.id, // EMPTY_GUID for the placeholder
      position: { x: 0, y: 0 },
      size: {
        width: Math.max(plateWidth - 2 * sideDuctWidth, 0),
        height: ductArticle.size?.width ?? 0,
        depth: ductArticle.size?.depth ?? 40,
      },
    };
  }

  // 2) Convert Scenario.Sections → SectionPlacement list
  const sectionPlacements = scenario.sections.map((section) => {
    const sectionPlacementId = uuidv4();

    return {
      // Placement fields
      id: sectionPlacementId,
      referenceId: section.id, // IMPORTANT: link to Scenario Section ID
      parentId: enclosure.id, // belongs to EnclosurePlacement
      position: { x: 0, y: 0 }, // backend will compute correct geometry
      size: { width: 0, height: 0 }, // backend will replace with real values

      // SectionPlacement fields
      order: getOrderFor(section.id),
      subGroupPlacements: [],

      // Duct above the section (from Settings.DuctsSectionsId)
      ductTop: createTopDuct(sectionPlacementId),
    };
  });

  // Sort by order
  return sectionPlacements.sort((a, b) => a.order - b.order);
}
